import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './phone_number_input.scss';
import { Form } from 'react-bootstrap-5';

import { getCountriesForPicker, getPinnedCountries } from 'helpers/countries';
import { fetchTranslation } from 'helpers/i18n';

const INVALID_PHONE_FALLBACK = "This phone number doesn't appear to be valid.";

// A handful of entries in countries.js use non-ISO codes (id 0 "Other"; id 11
// "UK" instead of the standard "GB"). Translate them before handing off to
// react-phone-number-input, which only understands ISO 3166-1 alpha-2.
const ISO_OVERRIDES = {
  Other: undefined,
  UK: 'GB',
};

function normalizeIso(isoCode) {
  if (Object.prototype.hasOwnProperty.call(ISO_OVERRIDES, isoCode)) {
    return ISO_OVERRIDES[isoCode];
  }
  return isoCode;
}

const PICKER_COUNTRIES = getCountriesForPicker()
  .map(c => normalizeIso(c.isoCode))
  .filter(Boolean);

// Build pinned order from countries.js (mirrors `pin_index` in countries.yml).
// '|' renders a divider; '...' separates the pinned top section from the
// alphabetically-sorted remainder. See react-phone-number-input docs.
const COUNTRY_OPTIONS_ORDER = [
  ...getPinnedCountries().map(c => normalizeIso(c.isoCode)).filter(Boolean),
  '|',
  '...'
];

export default function PhoneNumberInput({
  inputComponent = Form.Control,
  value,
  ...props
}) {
  const [touched, setTouched] = useState(false);
  const showError = touched && !!value && !isValidPhoneNumber(value);

  return (
    <React.Fragment>
      <PhoneInput
        countries={PICKER_COUNTRIES}
        countryOptionsOrder={COUNTRY_OPTIONS_ORDER}
        inputComponent={inputComponent}
        value={value}
        onBlur={() => setTouched(true)}
        {...props}
      />
      {showError && (
        <Form.Text className="text-danger">
          {fetchTranslation('invalid_phone_number', null, INVALID_PHONE_FALLBACK)}
        </Form.Text>
      )}
    </React.Fragment>
  );
}

PhoneNumberInput.propTypes = {
  inputComponent: PropTypes.elementType,
  value: PropTypes.string,
};
